import { applyMiddleware, combineReducers, createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import { authReducer, AuthState } from "./module/auth/authReducer";
import { createEpicMiddleware } from "redux-observable";
import { reducer as toastrReducer } from "react-redux-toastr";
import { beaconReducer, BeaconState } from "./module/beacon/beaconReducer";
import { countryReducer, CountryState } from "./module/country/countryReducer";
import {
  organizationReducer,
  OrganizationState,
} from "./module/organization/organizationReducer";
import {
  userMonitorEventReducer,
  UserMonitorEventState,
} from "./module/user-monitor-event/userMonitorEventReducer";
import {
  userProfileReducer,
  UserProfileState,
} from "./module/user-profile/userProfileReducer";
import { serviceContainerBuilder } from "./serviceContainer";
import { config } from "./config";
import { userReducer, UserState } from "./module/user/userReducer";
import { appInitAction } from "./module/common/commonActions";
import { commonReducer, CommonState } from "./module/common/commonReducer";
import { venueReducer, VenueState } from "./module/venue/venueReducer";
import { tagReducer, TagState } from "./module/tag/tagReducer";
import {
  promotionCodeReducer,
  PromotionCodeState,
} from "./module/promotion-code/promotionCodeReducer";
import rootEpic from "./rootEpic";
import {
  PartnershipState,
  partnershipReducer,
} from "./module/partnership/partnershipReducer";
import {
  EmailTemplateState,
  emailTemplateReducer,
} from "./module/email-template/emailTemplateReducer";
import {
  AdminUserState,
  adminUserReducer,
} from "./module/admin-user/adminUserReducer";
import {
  MemberCardPoolState,
  memberCardPoolReducer,
} from "./module/member-card-pool/memberCardPoolReducer";
import { shopReducer, ShopState } from "./module/shop/shopReducer";

export interface RootState {
  auth: AuthState;
  common: CommonState;
  country: CountryState;
  user: UserState;
  venue: VenueState;
  tag: TagState;
  userProfile: UserProfileState;
  userMonitorEvent: UserMonitorEventState;
  organization: OrganizationState;
  memberCardPool: MemberCardPoolState;
  beacon: BeaconState;
  promotionCode: PromotionCodeState;
  partnership: PartnershipState;
  emailTemplate: EmailTemplateState;
  adminUser: AdminUserState;
  shop: ShopState;
}

const rootReducer = combineReducers({
  auth: authReducer,
  common: commonReducer,
  country: countryReducer,
  user: userReducer,
  venue: venueReducer,
  tag: tagReducer,
  toastr: toastrReducer,
  userProfile: userProfileReducer,
  userMonitorEvent: userMonitorEventReducer,
  organization: organizationReducer,
  memberCardPool: memberCardPoolReducer,
  beacon: beaconReducer,
  promotionCode: promotionCodeReducer,
  partnership: partnershipReducer,
  emailTemplate: emailTemplateReducer,
  adminUser: adminUserReducer,
  shop: shopReducer,
});

const epicMiddleware = createEpicMiddleware({
  dependencies: serviceContainerBuilder(config),
});

const store = createStore(
  rootReducer,
  composeWithDevTools(applyMiddleware(epicMiddleware))
);

epicMiddleware.run(rootEpic);

store.dispatch(appInitAction());

export default store;
